import React, { useState, useEffect } from "react";
import { Row, Col, Button, Form, message, Spin } from "antd";
import { useForm, useWatch } from "react-hook-form";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { InputField, ReactSelectField, DateField, InputCheckbox } from "../../../../../atoms/FormElement";
import { propertyService } from "../../../../../../configs/constants";
import axios from "../../../../../../utils/axiosInceptor";
import { getConfigData } from "../../ducks/actions";
import { translateService } from "../../../../BookingForm/ducks/services";
import KycDetails from "../../../../BookingForm/components/KycDetails";
import { kycDataFields } from "../../../../../../utils/helper";
import { useMaskedFields } from "./useMaskedFields";
import { buildDocumentsPayload, buildTenantPayload, docMaskingFields, validateFields } from "../../utils";

var _ = require("lodash");

const EditTenant = (props) => {
  const { editType, onCancel, kycDetails, info, docs, userDetail, tenantDetail, isBlockedUser, userKycInfo } = props;
  type FormValues = {
    EmiratesIDExpiryDate?: string;
    PassportNumber?: string;
    VisaNumber?: string;
    TradeLicenseNumber?: string;
    TRNNumber?: string;
    [key: string]: any;
  };
  const [submited, setSubmited] = useState(false);
  const [isError, setisError] = useState(false);
  const [loader, setLoader] = useState(false);
  const [emiratesList, setEmiratesList] = useState([]);
  const [nationality, setNationality] = useState([]);

  let timeOutId: any = "";

  const {
    control,
    formState: { errors },
    reset,
    handleSubmit,
    setValue,
    setError,
    getValues,
  } = useForm();

  const fullName = useWatch({ control, name: "FullName" });

  useEffect(() => {
    if (fullName && fullName.length > 1) {
      clearTimeout(timeOutId);

      timeOutId = setTimeout(async () => {
        const response = await translateService(fullName);
        if (response?.translatedText) setValue("arabicName", response?.translatedText);
      }, 2000);
    }
  }, [fullName]);

  useEffect(() => {
    (async () => {
      const configKeys = ["nationalityList", "emiratesList"];
      const configData = await getConfigData(configKeys.join(","));

      let nationalities, emiratesList;

      configData.forEach((data) => {
        if (data["nationalityList"]) {
          nationalities = data["nationalityList"];
          nationalities = _.map(nationalities, (item) => ({
            value: item,
            label: item,
          }));
          setNationality(nationalities);
        }

        if (data["emiratesList"]) {
          emiratesList = data["emiratesList"];
          emiratesList = _.map(emiratesList, (item) => ({
            value: item,
            label: item,
          }));
          setEmiratesList(emiratesList);
        }
      });
    })();
  }, []);

  const { editingFields, initialize, resetField, setEditMode, preparePayload } = useMaskedFields(docMaskingFields);

  useEffect(() => {
    let updateArray = info.concat(docs);
    for (const [key, value] of Object.entries(tenantDetail || {})) {
      value && updateArray.push({ key: key, value: value });
    }

    updateArray.forEach((ele) => {
      let keyValue = ele.key.replace("Reg.", "").split(" ").join("");
      let keyNew = ele.value === "N/A" ? "" : ele.value;

      // -----------------------------
      // store original for masked fields
      // -----------------------------

      if (keyValue === "Emirates" || keyValue === "Nationality" || keyValue === "Country") {
        setValue(
          keyValue,
          (keyNew && {
            value: keyNew,
            label: keyNew,
          }) ||
            "",
          { shouldValidate: true },
        );
      } else if (
        keyValue === "PassportExpiryDate" ||
        keyValue === "VisaExpiryDate" ||
        keyValue === "TradeLicenseExpiryDate" ||
        keyValue === "EmiratesIDExpiryDate"
      ) {
        setValue(keyValue, keyNew && dayjs(keyNew, "DD-MM-YYYY"), { shouldValidate: true });
      } else {
        setValue(keyValue, keyNew, { shouldValidate: true });
      }
    });

    initialize(updateArray);
    if (editType === "Tenant Details" || editType === "Documents") {
    } else {
      reset();
    }
  }, [props]);

  const onFinish = async (values) => {
    const currentValues = getValues() as FormValues;
    // ✅ ONLY this (no transform needed anymore)
    const changedData = preparePayload(currentValues);

    const error = validateFields(values, changedData, editType);
    if (error) {
      setError(error.field, { type: "manual", message: error.message });
      return;
    }
    setSubmited(true);
    setLoader(true);

    let postJson = {};
    let kycData = kycDataFields(values);
    if (Object.keys(kycData).length > 0 && editType === 1) {
      postJson["kycData"] = kycData;
    } else {
      postJson = editType === "Documents" ? buildDocumentsPayload(changedData) : buildTenantPayload(values);
    }

    // if nothing valid changed → just close modal
    if (Object.keys(postJson).length === 0) {
      setLoader(false);
      setSubmited(false);
      onCancel();
      return false;
    }

    postJson["leaseUpdate"] = "yes";
    const url = `${propertyService}/tenant/user/${userDetail.userId}`;
    axios
      .patch(url, postJson)
      .then((response) => {
        let { data } = response;
        setLoader(false);
        setSubmited(false);
        reset();
        message.success(data?.message);
        props.onSubmit();
      })
      .catch((error) => {
        message.error(error.response.data.error);
        setLoader(false);
        setSubmited(false);
      });
  };

  return (
    <>
      <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
        {loader && !isError && (
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "35vh" }}>
                <div>
                  <Spin size="large" className="ag-fontSize32" />
                </div>
              </div>
            </Col>
          </Row>
        )}
        {!submited ? (
          <>
            {editType === "Tenant Details" && (
              <Row gutter={24}>
                <Col span={12}>
                  <InputField
                    fieldname="FullName"
                    label="Full Name"
                    control={control}
                    rules={{
                      required: "Please enter full name",
                    }}
                    iProps={{ placeholder: "Enter Full Name" }}
                    initValue=""
                  />
                </Col>

                <Col span={12}>
                  <InputField
                    isRequired={true}
                    control={control}
                    setValue={setValue}
                    fieldname="arabicName"
                    label="Tenant Name Arabic"
                    iProps={{ placeholder: "جون سميث" }}
                    disabled={true}
                    validate={errors.arabicName && "error"}
                    validMessage={errors.arabicName && errors.arabicName.message}
                    rules={{
                      required: "Please enter tenant arabic name",
                      pattern: {
                        value: /[\u0600-\u06FF]/,
                        message: "Please enter valid tenant arabic name",
                      },
                    }}
                  />
                </Col>
                <Col span={12}>
                  <InputField
                    fieldname="Email"
                    label="Email"
                    control={control}
                    rules={{
                      pattern: {
                        value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                        message: "Enter valid Email Address",
                      },
                    }}
                    validate={errors.Email && "error"}
                    validMessage={errors.Email && errors.Email.message}
                    iProps={{ placeholder: "user@gmail.com" }}
                    disabled={props.editMode}
                    initValue=""
                  />
                </Col>
                <Col span={12}>
                  <InputField
                    label="Phone"
                    fieldname="PhoneNumber"
                    control={control}
                    initValue=""
                    rules={{
                      minLength: {
                        value: 9,
                        message: "Please enter valid mobile number, 9 digits required",
                      },
                      maxLength: {
                        value: 9,
                        message: "Please enter valid mobile number, 9 digits required",
                      },
                      setValueAs: (value) => `${value}`,
                    }}
                    disabled={props.editMode}
                    iProps={{
                      placeholder: "Add Mobile Number",
                      addonBefore: "+971",
                      type: "number",
                      className: "apperance",
                    }}
                  />
                </Col>
                <Col span={12}>
                  <InputField
                    fieldname="Address"
                    label="Address"
                    control={control}
                    iProps={{ placeholder: "Enter Address" }}
                    initValue=""
                  />
                </Col>
                <Col span={12}>
                  <ReactSelectField
                    label="Country"
                    fieldname="Country"
                    control={control}
                    initValue=""
                    iProps={{ placeholder: "Select Country" }}
                    selectOption={nationality}
                  />
                </Col>
                <Col span={12}>
                  <ReactSelectField
                    label="Nationality"
                    fieldname="Nationality"
                    control={control}
                    initValue=""
                    iProps={{ placeholder: "Select Nationality" }}
                    selectOption={nationality}
                  />
                </Col>
                <Col span={12}>
                  <ReactSelectField
                    label="Emirates"
                    fieldname="Emirates"
                    control={control}
                    initValue=""
                    iProps={{ placeholder: "Select Emirates" }}
                    selectOption={emiratesList}
                  />
                </Col>

                <Col span={12}>
                  {
                    <InputCheckbox
                      fieldname="isBlocked"
                      key={isBlockedUser}
                      label={"Blacklist"}
                      initValue={isBlockedUser || false}
                      control={control}
                      validate={errors.isBlocked && "error"}
                      validMessage={errors.isBlocked && errors.isBlocked.message}
                      valueGot={isBlockedUser}
                      checkedValue={false}
                      setValue={setValue}
                    />
                  }
                </Col>
              </Row>
            )}

            {editType === "Documents" && (
              <Row gutter={24}>
                <Col span={12}>
                  <InputField
                    readOnly={true}
                    fieldname="PassportNumber"
                    label="Passport Number"
                    control={control}
                    iProps={{
                      placeholder: "Enter Passport Number",
                      readOnly: !editingFields["PassportNumber"],
                      addonBefore: (
                        <span style={{ display: "flex", gap: 6 }}>
                          {!editingFields["PassportNumber"] ? (
                            <EditOutlined
                              onClick={() => setEditMode("PassportNumber", setValue)}
                              style={{ cursor: "pointer" }}
                            />
                          ) : (
                            <CloseOutlined
                              onClick={() => resetField("PassportNumber", setValue)}
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </span>
                      ),
                    }}
                    initValue=""
                    validate={errors.PassportNumber && "error"}
                    validMessage={errors.PassportNumber && errors.PassportNumber.message}
                  />
                </Col>
                <Col span={12}>
                  <DateField
                    label="Passport Expiry Date"
                    fieldname="PassportExpiryDate"
                    control={control}
                    initValue=""
                    iProps={{
                      placeholder: "DD-MM-YYYY",
                      format: "DD-MM-YYYY",
                    }}
                  />
                </Col>
                <Col span={12}>
                  <InputField
                    fieldname="VisaNumber"
                    label="Visa Number"
                    control={control}
                    iProps={{
                      placeholder: "Enter Visa Number",
                      readOnly: !editingFields["VisaNumber"],
                      addonBefore: (
                        <span style={{ display: "flex", gap: 6 }}>
                          {!editingFields["VisaNumber"] ? (
                            <EditOutlined
                              onClick={() => setEditMode("VisaNumber", setValue)}
                              style={{ cursor: "pointer" }}
                            />
                          ) : (
                            <CloseOutlined
                              onClick={() => resetField("VisaNumber", setValue)}
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </span>
                      ),
                    }}
                    initValue=""
                    validate={errors.VisaNumber && "error"}
                    validMessage={errors.VisaNumber && errors.VisaNumber.message}
                  />
                </Col>
                <Col span={12}>
                  <DateField
                    label="Visa Expiry Date"
                    fieldname="VisaExpiryDate"
                    control={control}
                    initValue=""
                    iProps={{
                      placeholder: "DD-MM-YYYY",
                      format: "DD-MM-YYYY",
                    }}
                  />
                </Col>
                <Col span={12}>
                  <InputField
                    fieldname="TradeLicenseNumber"
                    label="Trade License Number"
                    control={control}
                    iProps={{
                      placeholder: "Enter Trade License Number",
                      readOnly: !editingFields["TradeLicenseNumber"],
                      addonBefore: (
                        <span style={{ display: "flex", gap: 6 }}>
                          {/* EDIT ICON */}
                          {!editingFields["TradeLicenseNumber"] ? (
                            <EditOutlined
                              onClick={() => setEditMode("TradeLicenseNumber", setValue)}
                              style={{ cursor: "pointer" }}
                            />
                          ) : (
                            /* CLOSE ICON */
                            <CloseOutlined
                              onClick={() => resetField("TradeLicenseNumber", setValue)}
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </span>
                      ),
                    }}
                    initValue=""
                    validate={errors.TradeLicenseNumber && "error"}
                    validMessage={errors.TradeLicenseNumber && errors.TradeLicenseNumber.message}
                  />
                </Col>
                <Col span={12}>
                  <DateField
                    label="Trade License Expiry Date"
                    fieldname="TradeLicenseExpiryDate"
                    control={control}
                    initValue=""
                    iProps={{
                      placeholder: "DD-MM-YYYY",
                      format: "DD-MM-YYYY",
                    }}
                  />
                </Col>
                <Col span={12}>
                  <InputField
                    fieldname="EmiratesIDNumber"
                    label="Emirates Id Number"
                    control={control}
                    iProps={{
                      placeholder: "Enter Emirates Id Number",
                      readOnly: !editingFields["EmiratesIDNumber"],
                      addonBefore: (
                        <span style={{ display: "flex", gap: 6 }}>
                          {!editingFields["EmiratesIDNumber"] ? (
                            <EditOutlined
                              onClick={() => setEditMode("EmiratesIDNumber", setValue)}
                              style={{ cursor: "pointer" }}
                            />
                          ) : (
                            <CloseOutlined
                              onClick={() => resetField("EmiratesIDNumber", setValue)}
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </span>
                      ),
                    }}
                    validate={errors.EmiratesIDNumber && "error"}
                    validMessage={errors.EmiratesIDNumber && errors.EmiratesIDNumber.message}
                  />
                </Col>
                <Col span={12}>
                  <DateField
                    label="Emirates Expiry Date"
                    fieldname="EmiratesIDExpiryDate"
                    control={control}
                    initValue=""
                    iProps={{
                      placeholder: "DD-MM-YYYY",
                      format: "DD-MM-YYYY",
                    }}
                  />
                </Col>
                <Col span={12}>
                  <InputField
                    fieldname="TRNNumber"
                    label="TRN Number"
                    control={control}
                    iProps={{
                      placeholder: "Enter TRN Number",
                      addonBefore: (
                        <span style={{ display: "flex", gap: 6 }}>
                          {!editingFields["TRNNumber"] ? (
                            <EditOutlined
                              onClick={() => setEditMode("TRNNumber", setValue)}
                              style={{ cursor: "pointer" }}
                            />
                          ) : (
                            <CloseOutlined
                              onClick={() => resetField("TRNNumber", setValue)}
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </span>
                      ),
                    }}
                    initValue=""
                    validate={errors.TRNNumber && "error"}
                    validMessage={errors.TRNNumber && errors.TRNNumber.message}
                  />
                </Col>
              </Row>
            )}
            {editType === 1 && (
              <Row gutter={24}>
                <KycDetails
                  bookingDetails={{}}
                  control={control}
                  errors={errors}
                  colSpan={12}
                  kycDetail={kycDetails}
                  setValue={setValue}
                  userKycInfo={userKycInfo}
                />
              </Row>
            )}

            <Row gutter={24} justify="space-between" style={{ marginTop: "20px" }}>
              <Col>
                <Button
                  className="ag-gray-button-outline theme_grey_btn"
                  htmlType="button"
                  onClick={() => {
                    onCancel();
                  }}
                >
                  Back
                </Button>
              </Col>
              <Col>
                <Button className="ag-green-button theme_btn" htmlType="submit">
                  {"Update"}
                </Button>
              </Col>
            </Row>
          </>
        ) : (
          isError && (
            <>
              <Row gutter={24}>
                <Col span={24}>
                  <Button
                    className="ag-gray-button-outline theme_grey_btn"
                    htmlType="button"
                    onClick={() => {
                      reset();
                      setSubmited(false);
                      setisError(false);
                    }}
                  >
                    Back
                  </Button>
                </Col>
              </Row>
            </>
          )
        )}
      </Form>
    </>
  );
};

export default EditTenant;
